var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckGradient = function SvgCheckGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#check-gradient_svg__a)",
    d: "m12.16 3.438-1.551-.69-.691-1.553-1.689.176L6.855.375l-1.374.996-1.688-.176-.69 1.552-1.553.69.177 1.69L.73 6.5l.997 1.375-.177 1.688 1.552.69.691 1.552 1.689-.176 1.373.996 1.375-.996 1.688.176.69-1.552 1.553-.69-.177-1.69.996-1.373-.996-1.375zM5.63 8.95 3.897 7.217l.578-.576L5.63 7.794 9.095 4.33l.578.577z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check-gradient_svg__a",
    x1: 6.857,
    x2: 6.857,
    y1: 12.625,
    y2: 0.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA1B"
  })))));
};
export default SvgCheckGradient;